import styled from "styled-components";

export const StyledButton = styled.button`
  cursor: pointer;
  background: var(--navy);
  border-radius: var(--radius-sm);
  padding: 16px;
  border: none;
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.02em;
  color: #ffffff;
  width: 100%;
  transition: var(--transition);

  &:hover {
    background: var(--navy-light);
    box-shadow: var(--shadow-navy);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
    background: var(--gray-400);
  }
`;
